import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_DEPOSITO } from '../../data.const';
import {
  setCurrentDepositoAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveDepositoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_DEPOSITO),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_DEPOSITO}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ depositoLoader: true })),
        defer(() =>
          from(
            request({ path: `deposito/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_DEPOSITO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentDepositoAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_DEPOSITO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ depositoLoader: false }))
      );
    })
  );

export default retrieveDepositoEpic;
